export default {
	benefits: {
		title: "Avantages",
		wide_audience: {
			title: "Atteignez un large public",
			description: "Nous sommes en train de construire le plus grand panel de consommateurs en ligne en Afrique"
		},
		fast: {
			title: "Obtenez des résultats rapidement",
			description: "Commencez à obtenir des résultats en quelques heures au lieu d'attendre des semaines"
		},
		money: {
			title: "Économisez de l'argent",
			description: "Tout cela pour une fraction du coût des méthodes traditionnelles"
		}
	},
	products: {
		title: "Notre offre",
		survey: {
			title: "Envoyer un sondage",
			description: "Créez des sondages professionnels en quelques minutes et atteignez un large public en appuyant simplement sur un bouton",
		},
		reactions: {
			title: "Recueillir les réactions des gens ",
			description: "Vous avez accès aux réactions émotionnelles des gens qui ont regardé votre contenu, permettant ainsi de capturer des données non biaisées sur ce que votre audience aime",
		}
	},
	use_cases: {
		title: "Cas d'utilisation",
		ad_video: {
			title: "Testez votre pub vidéo",
			description: "Envoyez-nous votre vidéo et nous vous montrerons les émotions qu’elle suscite auprès des gens ",
		},
		billboard: {
			title: 'Testez votre panneau publicitaire',
			description: "Envoyez vos différentes campagnes et nous vous dirons celles qui auront un impact fort sur votre public cible"
		},
		market_research: {
			title: 'Étude de marché',
			description: 'Avec des sondages en temps réel, recevez directement du feedback clients pour votre étude de marché: tarification, développement de produits, etc.',
		}
	},
	dashboard: "Dashboard",admin: "Admin",
	sign_in: "Se connecter",
	sign_out: "Se déconnecter",
	title: "Avant de lancer vos concepts, testez-les!",
	sub_title: "Atteignez les consommateurs - n'importe où, n'importe quand - pour recueillir leurs réactions sur vos concepts",
	learn_more: "En savoir plus",
	get_started: "Essayez",
	our_platform: {
		title: "Notre plateforme",
		description: " vous permet d’avoir accès aux consommateurs pour recueillir leurs commentaires et réactions, afin de comprendre ce qu'ils pensent de vos concepts pour confirmer si cela s'applique à un public plus large"
	},
	our_offer: {
		title: "Notre offre",
		description: "Nous offrons une combinaison de produits vous permettant de tester vos concepts avant leur lancement et d'optimiser votre retour sur investissement sur vos dépenses"
	},
	use_case_example: "Exemple #{0}",
	contact_us: {
		title: "Envie d\'en savoir plus?",
		name: "Votre prénom",
		email: "Votre email",
		phone: "(ou) votre numéro de téléphone",
		message: "Laissez-nous un message",
		submit: "Contactez-nous!",
		close: "Close"
	},
	marketIntelligence: {
		title: 'Digitalisez votre collecte de données',
		description: 'Connectez vous pour administrer vos campagnes de collection de données en utilisant vos agents terrain! Si vous n\'en disposez pas, vous pouvez vous appuyer sur notre réseau d\'agents de terrain et panelistes!'
	},
	sign_in_success: 'Connexion réussie',
	sign_in_error: 'Echec - Veuillez vérifier vos identifiants et réessayer',
	email_address: 'Adresse email',
	password: 'Mot de passe',
	submit: 'Valider',
	field_mandatory: 'Ce champ est obligatoire',
	email_mandatory: 'Vous devez indiquer une adresse email',
	email_format: 'Veuillez entrer une adresse au format valide',
};